import QuestionService from '@/services/suppliers/QuestionService';

const questionService = new QuestionService();

export const getAllLibraryQuestions = async({ commit }: {commit: Function}, payload?: any) => {
    commit('isFetching', true);
    const questions = await questionService.getAllLibraryQuestions(payload);
    commit('allLibraryQuestions', questions);
    commit('isFetching', false);
}

export const getLibraryQuestion = async({ commit }: {commit: Function}, questionId: string) => {
    const question = await questionService.getLibraryQuestion(questionId);
    commit('selectedQuestion', question);
    return question;
}

export const createLibraryQuestion = async({ commit }: {commit: Function}, payload: any) => {
    await questionService.createLibraryQuestion(payload.question);
}

export const updateLibraryQuestionWip = async({ commit }: { commit: Function }, payload: any) => {
    await questionService.updateLibraryQuestionWip(payload.questionId, payload.question);
}

export const publishLibraryQuestion = async({ commit }: {commit: Function}, payload: any) => {
    await questionService.publishLibraryQuestion(payload.questionId);
}

export const getQuestionHistory = async({ commit }: {commit: Function}, questionId: string) => {
    const history = await questionService.getQuestionHistory(questionId);
    commit('questionHistory', history);
    return history;
}

export const restoreQuestionVersion = async({ commit }: {commit: Function}, payload: any) => {
    await questionService.restoreQuestionVersion(payload.questionId, payload.eventId);
}

export const deleteLibraryQuestion = async({ commit }: {commit: Function}, questionId: string) => {
    await questionService.deleteLibraryQuestion(questionId);
}

export const getQuestionTags = async({ commit }: {commit: Function}) => {
    const tags = await questionService.getQuestionTags();
    commit('allTags', tags);
    return tags;
}

export const getQuestionCategories = async({ commit }: {commit: Function}) => {
    const categories = await questionService.getQuestionCategories();
    commit('allCategories', categories);
    return categories;
}

export const updateQuestionCategories = async({ commit }: {commit: Function}, categories: any[]) => {
    await questionService.updateQuestionCategories(categories);
}
